import { Box, Image, Textarea } from '@chakra-ui/react';
import Zoom from 'react-medium-image-zoom';
import fallbackIcon from '../../../../global/styles/images/fallback-icon.png'

export const ImageSubWidget = ({ subWidgetId, editableItemId,setSubWidgetContent, subWidgetContent}) => {

  return (
    editableItemId === subWidgetId
      ? <Box width="100%">
          <Textarea
            autoFocus
            value={subWidgetContent} 
            onChange={(e) => setSubWidgetContent(e.target.value)}
            resize="none"
            boxSize="lg"
          />
        </Box>
      : <Box padding="10px">
          <Zoom>
           <Image src={subWidgetContent || fallbackIcon} alt="Sub-widget image" />
          </Zoom>
      </Box>
  )
};
